import { emulatorScreen, mobileScreen } from "../../utils/styleUtils";

const styles = (theme) => ({
  homeScreenContainer: {
    height: "85vh",
    backgroundColor: "#ecf2f1",
    [mobileScreen(theme)]: {
      height: "80vh",
    },
  },

  homeMainScreenContainer: {
    height: "100vh",
    backgroundColor: "#ecf2f1",
    overflow: "auto",
    padding: "2rem",
    [mobileScreen(theme)]: {
      padding: "1rem",
    },
  },

  homeTitle: {
    color: "#003e4c",
    fontFamily: "Oswald",
    fontSize: "80px",
    fontWeight: "500",
    [mobileScreen(theme)]: {
      fontSize: "35px",
    },
  },

  homeQuestion: {
    color: "#003e4c",
    fontFamily: "Oswald",
    fontSize: "45px",
    fontWeight: "500",
    [mobileScreen(theme)]: {
      fontSize: "20px",
    },
  },

  gdpIcon: {
    width: "550px",
    height: "340px",
    margin: "50px 0",
    [mobileScreen(theme)]: {
      width: "210px",
      height: "110px",
      margin: "12px 0",
    },
  },

  playButton: {
    backgroundColor: "#00b1d9",
    color: "#fff",
    fontSize: "55px",
    fontWeight: "500",
    padding: "0 65px",
    borderRadius: "0",
    lineHeight: "1.4",
    margin: "24px 0",
    fontFamily: "'Oswald', sans-serif",
    "&:hover": {
      backgroundColor: "#056f8a",
    },
    [mobileScreen(theme)]: {
      padding: "0 30px",
      fontSize: "22px",
      margin: "15px 0",
    },
  },

  mruLogo: {
    alignItems: "flex-end",
    display: "flex",
  },

  mruLogoContainer: {
    height: "8vh",
  },

  logoImg: {
    width: "110px",
    [mobileScreen(theme)]: {
      width: "80px",
    },
  },
});

export default styles;
